/**
 * Created by andrey on 08.08.2025
 */

cc.JumpBy = function (duration, position, y, height, jumps) {
    cc.ActionInterval.prototype.constructor.call(this);

    this._startPosition = cc.p(0, 0);
    this._previousPosition = cc.p(0, 0);
    this._delta = cc.p(0, 0);

    this._height = 0;
    this._jumps = 0;

    if (height !== undefined) {
        this.initWithDuration(duration, position, y, height, jumps);
    }
};

cc.JumpBy.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.JumpBy,

    initWithDuration: function (duration, position, y, height, jumps) {
        if (cc.ActionInterval.prototype.initWithDuration.call(this, duration)) {
            if (jumps === undefined) {
                jumps = height;
                height = y;
                y = position.y;
                position = position.x;
            }
            this._delta.x = position;
            this._delta.y = y;
            this._height = height;
            this._jumps = jumps;
            return true;
        }
        return false;
    },

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);
        const locPosX = target.getPositionX();
        const locPosY = target.getPositionY();
        this._previousPosition.x = locPosX;
        this._previousPosition.y = locPosY;
        this._startPosition.x = locPosX;
        this._startPosition.y = locPosY;
    },

    update: function (dt) {
        dt = this._computeEaseTime(dt);
        if (this.target) {
            const frac = dt * this._jumps % 1.0;
            let y = this._height * 4 * frac * (1 - frac);
            y += this._delta.y * dt;

            let x = this._delta.x * dt;
            const locStartPosition = this._startPosition;
            if (cc.ENABLE_STACKABLE_ACTIONS) {
                const targetX = this.target.getPositionX();
                const targetY = this.target.getPositionY();
                const locPreviousPosition = this._previousPosition;

                locStartPosition.x = locStartPosition.x + targetX - locPreviousPosition.x;
                locStartPosition.y = locStartPosition.y + targetY - locPreviousPosition.y;
                x += locStartPosition.x;
                y += locStartPosition.y;
                locPreviousPosition.x = x;
                locPreviousPosition.y = y;
                this.target.setPosition(x, y);
            } else {
                this.target.setPosition(locStartPosition.x + x, locStartPosition.y + y);
            }
        }
    }
});

cc.jumpBy = (duration, position, y, height, jumps) => new cc.JumpBy(duration, position, y, height, jumps);
